exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".i-editor .color-card{margin:2px;width:30px;height:30px;float:left;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-9e8ad9ec!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/editor/src/modules/color/dashboard.vue
// module id = 473
// module chunks = 0